/**
 * TODO: change this to the project prefix, the project prefix will be used to prefix the resources created in the AWS account.
 * example. if the template has an ssm parameter all ssm parameters will start with /{projectPrefix}/
 */
export const projectPrefix: Readonly<string> = 'tran';

export const exportsBucketPrefix: Readonly<string> = 'exports/';

export const allowedPowerpointFileExtensions: ReadonlyArray<string> = ['pptx', 'ppt'];

export const allowedExcelFileExtensions: ReadonlyArray<string> = ['xlsx', 'xls', 'xlsm'];

export const allowedFileExtensions: ReadonlyArray<string> = [
    ...allowedPowerpointFileExtensions,
    ...allowedExcelFileExtensions
];

export const azureSiemensTenantId = '38ae3bcd-9579-4fd4-adda-b42e1495d55a';
